module.exports = __webpack_public_path__ + "static/media/image2.7f71e9c2.PNG";